/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Delivery_TitleInputs */

const en_services_delivery_title = /** @type {(inputs: Services_Delivery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The work around the software matters, too.`)
};

const lv_services_delivery_title = /** @type {(inputs: Services_Delivery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darbs ap programmatūru ir tikpat svarīgs.`)
};

/**
* | output |
* | --- |
* | "The work around the software matters, too." |
*
* @param {Services_Delivery_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_delivery_title = /** @type {((inputs?: Services_Delivery_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Delivery_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_delivery_title(inputs)
	return en_services_delivery_title(inputs)
});